export const showAboutUs = (AboutUs) =>
  Boolean(
    AboutUs &&
      (AboutUs?.Description ||
        AboutUs?.PhotoUrl ||
        AboutUs?.VisitingRules ||
        AboutUs?.EnvironmentalCertification ||
      (AboutUs?.OwnerAndFinancing && (
        AboutUs?.OwnerAndFinancing?.OwnerType ||
        AboutUs?.OwnerAndFinancing?.FinancingText ||
        AboutUs?.OwnerAndFinancing?.PriceLinks)
      )));

export const showVisitorinfo = (contactCard) =>
  Boolean(
    contactCard.AboutUs &&
      (contactCard.AboutUs.PatientInformation ||
        contactCard.AboutUs.ReferralRequirement ||
        (contactCard.AboutUs.PatientAge &&
          contactCard.AboutUs.PatientAge.length > 0) ||
        contactCard.AboutUs.VisitingRules ||
        (contactCard.VisitingHours && contactCard.VisitingHours.length > 0))
  );

export const showOffering = (contactCard) => {
  return Boolean(
    (contactCard && contactCard.Offers && contactCard.Offers.length > 0) ||
      (contactCard && contactCard.GeneralText)
  );
};

export const showFindUs = (contactCard) =>
  Boolean(
    contactCard.Address ||
      (contactCard.Location &&
        contactCard.Location.latitude &&
        contactCard.Location.longitude) ||
      contactCard.County ||
      contactCard.PostalAddress ||
      contactCard.WebsiteUrl ||
      contactCard.IndoorRouteDescription ||
      contactCard.RoadDescription
  );

export const showPatientInformation = (patientInformationCard) =>
  Boolean(patientInformationCard && patientInformationCard?.length > 0);

export const showFindCareHow = (findCareHowCard) =>
  Boolean(
    findCareHowCard?.Information ||
    findCareHowCard?.ReferralRequirements ||
      findCareHowCard?.PatientAge
  );

export const showInfoVisitor = (InfoVisitorCard) =>
  Boolean(
    InfoVisitorCard?.Ingress ||
    InfoVisitorCard?.Descriptions ||
      (InfoVisitorCard.VisitingHours &&
        InfoVisitorCard?.VisitingHours?.Schedule?.length > 0)
  );

export const showYourVisit = (YourVisitCard) =>
  Boolean(
    YourVisitCard &&
      (YourVisitCard?.BeforeVisit ||
        YourVisitCard?.DuringVisit ||
        YourVisitCard?.AfterVisit ||
        YourVisitCard?.Preamble)
  );

export const showBusinessHours = (BusinessHoursCard) =>
  BusinessHoursCard?.Open?.Schedule ||
  (BusinessHoursCard?.ShowDropinCompact
    ? BusinessHoursCard?.DropinCompact?.Schedule
    : BusinessHoursCard?.Dropin?.Schedule);

export const showPracticalInformation = (PracticalInformationCard) =>
  Boolean(
    PracticalInformationCard?.Facilities?.length > 0 ||
      PracticalInformationCard?.Preamble
  );

export const showUnitQualityIndicators = (UnitQualityIndicators) =>
  UnitQualityIndicators?.Indicators &&
  UnitQualityIndicators.Indicators.length > 0 &&
  !UnitQualityIndicators.Indicators.some(
    (indicator) =>
      !indicator?.MeasureValues ||
      indicator.MeasureValues.length === 0 ||
      indicator.MeasureValues.some((value) => value?.Value == null)
  );

export const showListing = (Listing) =>
  Listing &&
  Object.values(Listing).every(
    (value) => value !== undefined && value !== null
  );
